/* Hotjar crosstab events */
export const HJ_DICTIONARY_SCRATCH_VPV = '/dictionary/scratch';
export const HJ_DICTIONARY_RECYCLE_VPV = '/dictionary/recycle';
export const HJ_MOVE_TO_ROW_FROM_RECYCLE = 'MOVE_TO_ROW_FROM_RECYCLE';
export const HJ_MOVE_TO_BASE_FROM_RECYCLE = 'MOVE_TO_BASE_FROM_RECYCLE';
export const HJ_MOVE_TO_COLUMN_FROM_RECYCLE = 'MOVE_TO_COLUMN_FROM_RECYCLE';
export const HJ_CROSSTAB_HIGHLIGHTING_FILTERING = '/essentials/crosstab/highlight';
export const HJ_CROSSTAB_HIGHLIGHTING_FILTERING_APPLY = '/essentials/crosstab/highlight/apply';
export const HJ_CROSSTAB_FULL_SHORT_LABEL_TOOGLE_MODE = '/essentials/crosstab/labels/fullshorttogglemode';
export const HJ_CROSSTAB_EDIT_EXPRESSION = '/essentials/crosstab/labels/editexpression';
export const HJ_CROSSTAB_CLEAR_SINGLE_ITEM = '/essentials/crosstab/labels/deletesingleitem';
export const HJ_CROSSTAB_CLEAR_ALL_ITEMS = '/essentials/crosstab/labels/deleteall';
export const HJ_CROSSTAB_SORT = '/essentials/crosstab/labels/sort';
export const HJ_CROSSTAB_ITEM_RESTORE = '/essentials/crosstab/labels/restore';
